'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var printDiv = function () {
    function printDiv() {
        _classCallCheck(this, printDiv);

        this.restrict = 'A';

        this.link = function (scope, element, attrs, modelCtrl) {
            var iframe;
            var elementToPrint = document.querySelector(attrs.printDiv);

            if (!window.frames['print-frame']) {
                var elm = document.createElement('iframe');
                elm.setAttribute('id', 'print-frame');
                elm.setAttribute('name', 'print-frame');
                elm.setAttribute('style', 'display: none;');
                document.body.appendChild(elm);
            }

            function write(value) {
                var doc;
                if (iframe.contentDocument) {
                    // DOM
                    doc = iframe.contentDocument;
                } else if (iframe.contentWindow) {
                    // IE win
                    doc = iframe.contentWindow.document;
                }
                doc.write(value);
                doc.close();
            }

            element.bind('click', function (event) {
                elementToPrint = document.querySelector(attrs.printDiv);
                iframe = document.getElementById('print-frame');
                write(elementToPrint.innerHTML);
                if (window.navigator.userAgent.indexOf('MSIE') > 0) {
                    iframe.contentWindow.document.execCommand('print', false, null);
                } else {
                    iframe.contentWindow.focus();
                    iframe.contentWindow.print();
                }
            });
        };
    }

    _createClass(printDiv, null, [{
        key: 'directiveFactory',
        value: function directiveFactory() {
            printDiv.instance = new printDiv();
            return printDiv.instance;
        }
    }]);

    return printDiv;
}();

exports.default = printDiv;


/** WEBPACK FOOTER **
 ** ./src/app/directives/print/printDiv.js
 **/